import { Observable } from 'rxjs/Observable'
import { makeCard } from './models'
import { encodeQueryData } from 'utils/Helpers'
import { IFRAMELY_KEY } from 'constants/ResourcesConstants'

export const fetchCard = (url, {
  key = IFRAMELY_KEY,
  omitScript = true,
  iframe = true,
} = {}) => {
  const params = {
    key,
    url,
    omit_script: omitScript ? 1 : 0,
    iframe: iframe ? 1 : 0,
  }
  return Observable.ajax({
    url: `//iframe.ly/api/iframely?${encodeQueryData(params)}`,
    method: 'GET',
    crossDomain: true,
    responseType: 'json',
  })
    .retryWithBackoff()
    .map((data) => makeCard(data.response))
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/cards/api.js